import(/* webpackMode: "eager", webpackExports: ["ErrorCaptureClient"] */ "/vercel/path0/src/app/ErrorCaptureClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["MenuMusicDirector"] */ "/vercel/path0/src/components/audio/MenuMusicDirector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/src/components/error/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackFab"] */ "/vercel/path0/src/components/feedback/FeedbackFab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateBanner"] */ "/vercel/path0/src/components/update/UpdateBanner.tsx");
